import EventOverview from '@/views/EventOverview.vue';
import Event from '@/views/Event.vue';
import EventTrackSearch from '@/components/event/EventTrackSearch.vue';
import EventPlaylist from '@/components/event/EventPlaylist.vue';
import EventGuestsAccess from '@/components/event/EventGuestsAccess.vue';

export default [
  {
    path: '',
    name: 'event.overview',
    component: EventOverview,
    meta: {
      requiresFinishedWizard: true,
      requiresSpotifyIsAuthorized: true,
    },
  },
  {
    path: 'event/:id?',
    component: Event,
    meta: {
      requiresFinishedWizard: true,
      requiresSpotifyIsAuthorized: true,
    },
    children: [
      {
        path: 'playlist',
        name: 'event.playlist',
        component: EventPlaylist,
      },
      {
        path: 'guests-access',
        name: 'event.guests.access',
        component: EventGuestsAccess,
      },
      {
        path: '',
        alias: 'track-search',
        name: 'event.track.search',
        component: EventTrackSearch,
      },
    ],
  },
];
